// Regular expression to match valid international phone numbers
function isValidPhoneNumber(phoneNumber) {
    if (phoneNumber) {
        // check if the phone number matches the regular expression
        return /^\+(?:\d\s*){5,}$/.test(phoneNumber);
    }
    return true;
}
export { isValidPhoneNumber };
